module.exports = __webpack_public_path__ + "static/media/hyundai.7259647e.png";